<div class="heading">
  Add offered services details
</div>
<div class="dropdown-container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="dropdown flex justify-content-between" style="margin-bottom: 24px; height: 40px; width: 100%">
      <div class="flex">
        <div class="serviceListscatagory">
          <label for="serviceCategory" style="font-size: 16px; font-weight: 600; margin-right: 6px;">Service lists
            for:</label>
        </div>
        <div class="focus:border-primary">
          <p-dropdown id="serviceCategory" [options]="serviceLists" optionLabel="label" dataKey="value"
            placeholder="Select a category" formControlName="selectedCategory" >
          </p-dropdown>
        </div>
      </div>
      <div class="search-container">
        <div class="w-full focus:border-primary">
          <i class="pi pi-search search-icon mr-2"></i>
          <input type="text" pInputText placeholder="Search Services" class="search-box" [value]="searchQuery"
            (input)="onSearchChange($event)"  />
        </div>
      </div>
    </div>

    <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>
    <button type="submit" pButton class="btn btn-primary mt-6">Next <i class="pi pi-arrow-right arrow-icon"
        style="margin-left: 8px;"></i></button>
  </form>
</div>

<app-add-service-modal *ngIf="showModal" [serviceName]="serviceNameToAdd"
  (confirmAdd)="onConfirmAddService($event)"></app-add-service-modal>